import type { NavigationProp, ParamListBase } from '@react-navigation/native';
import { useNavigation } from 'expo-router';

/**
 * Safely wraps `useNavigation` from `expo-router`.
 *
 * Returns `null` when called outside an expo-router context.
 */
export const useSafeExpoNavigation = (): NavigationProp<ParamListBase> | null => {
  try {
    return useNavigation();
  } catch {
    return null;
  }
};
